import styles from './Logo.module.css';

export default function Logo() {
  return <p className={styles.logo}>KRTD: The Night Radio</p>
}
